import ticketImg from '../../components/atomic/icons/ticket/ticket.png';
import arrowIconImg from './arrow_icon.png';
import rewardValueBackgroundImg from './reward_value_text_background.png';
import './TaskCard.css';

export type TaskCardTextLayout = {
  left: number;
  top: number;
  width: number;
  height: number;
};

export type TaskCardProps = {
  /** Screen Y of the card (Figma task_* top). */
  top: number;
  taskNameSrc: string;
  taskNameAlt: string;
  taskNameLayout: TaskCardTextLayout;
  rewardValueSrc: string;
  rewardValueAlt: string;
  rewardValueLayout: TaskCardTextLayout;
  /** Completed tasks are faded and not clickable. */
  completed?: boolean;
  onClick?: () => void;
};

/**
 * Task list card (Figma task_1 160:16781) — HTML shell + reward badge + texts + arrow.
 * Card: Left 84, 912×180.
 */
export function TaskCard({
  top,
  taskNameSrc,
  taskNameAlt,
  taskNameLayout,
  rewardValueSrc,
  rewardValueAlt,
  rewardValueLayout,
  completed = false,
  onClick,
}: TaskCardProps) {
  return (
    <button
      type="button"
      className={completed ? 'task-card task-card--completed' : 'task-card'}
      style={{ top }}
      aria-label={taskNameAlt}
      aria-disabled={completed || undefined}
      disabled={completed}
      onClick={completed ? undefined : onClick}
    >
      <div className="task-card__shell" aria-hidden>
        <div className="task-card__body" />
        <div className="task-card__arrow-bg" />
      </div>
      <img
        className="task-card__reward-bg"
        src={rewardValueBackgroundImg}
        alt=""
        draggable={false}
        aria-hidden
      />
      <img
        className="task-card__reward-value"
        src={rewardValueSrc}
        alt={rewardValueAlt}
        draggable={false}
        style={rewardValueLayout}
      />
      <img
        className="task-card__ticket"
        src={ticketImg}
        alt=""
        draggable={false}
        aria-hidden
      />
      <img
        className="task-card__name"
        src={taskNameSrc}
        alt=""
        draggable={false}
        aria-hidden
        style={taskNameLayout}
      />
      <img
        className="task-card__arrow-icon"
        src={arrowIconImg}
        alt=""
        draggable={false}
        aria-hidden
      />
    </button>
  );
}
